<template>

      <div id='saomiao_handle'  class="editor_wrap"  >
        <!-- <div class="header_"  v-if="!isMini">
          <div style="width:15%;cursor:pointer; ">
            <img   :src="require('@/assets/images/newlogo.png')"   width="134px" height="50px"  @click="BackToHome" >
        
          </div>
           
          <div style="width:35%;font-size:28px;color:#dedede; ">  </div> 
          
          <div class="head_operation"   >
         
                      
          </div>
          
          <div v-if="!isMini" class="loginAvatar">
     
            <el-avatar v-if="!$store.state.islogin" title="登录" :src="require('@/assets/images/touxiang.png')" style="margin-right:20px;cursor:pointer; " @error="errorHandler" @click.native="SignIn"  >
                  
            </el-avatar>

            <el-dropdown v-else >
        
              <el-avatar  :src="userInfo.avatarUrl" style="margin-right:20px;cursor:pointer" @error="errorHandler" >
                  <img :src="userInfo.avatarUrl"/>
              </el-avatar>
              <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="SignOut">退出登录</el-dropdown-item>

                  <el-dropdown-item  command="deposit"  @click.native="Turn2Charge" >
                  
                    <span class="iconfont"    >&#xe71b;</span>
                      充值({{$store.state.accountInfo.coins}})
                  </el-dropdown-item> 
                
              </el-dropdown-menu> 



            </el-dropdown>

          </div>

        
        </div> -->
        <!-- <button id="saveButton">保存图片</button> -->
        <div class="middle" :style="isphone? 'min-height:'+screenHeight*0.88+'px;width:'+screenWidth*0.98+'px;padding:5px;' :'min-height:'+screenHeight*0.88+'px' ">
          <!-- <div class="left"  v-if="!isphone"></div> -->
          <!-- :style=" isphone? 'width:94%;margin-left:auto;margin-right:auto;':'' " -->
          <div class="mid_"  :style="isphone?'width:100%':''">
            <h1 class="title" > 扫描助手 </h1> 

            <div class="mode_bar">
                <el-radio v-model="mode" label="ori" border> 原图</el-radio>
                <el-radio v-model="mode" label="bright" border> 提亮锐化 </el-radio>
                <el-radio v-model="mode" label="gray" border>黑白二值化</el-radio>
                <!-- <el-radio v-model="mode" label="pic2pdf" border>图片转pdf</el-radio> -->
                <!-- <el-radio v-model="mode" label="3" border>pdf文件合并</el-radio> -->

                <div  >   
                    <router-link  to="/community/y70b4361829502" target='_blank'  class="guide">   
                        不同模式介绍
                    </router-link>  

                </div>
            </div>

       
            <!-- <div   class="current_task">当前处理文件：  
                <span  class="choosen_file" v-for="(item,index ) of multipleSelection"  v-bind:key="item.uploadtime"> 【{{index+1}}】  {{item.fileName}}   </span>
   

            </div> -->

            <!-- <div  class="current_task"  v-if="mode=='split' && !param.split_everypage" style="border:none">  
                
                <el-form :inline="true"  size="mini"  >
                    <el-form-item label="分割的页码区间："  >
                        <el-col :span="6">
                      
                        <el-input v-model="param.startPage" placeholder="开始页"></el-input>
                        </el-col>
                        <el-col class="line" :span="2" style="text-align:center">-</el-col>
                        <el-col :span="6">
           
                        <el-input v-model="param.endPage" placeholder="结束页"></el-input>
                        </el-col>
                    </el-form-item> 


 
                </el-form>   

       

               
                
            </div> -->


 

          

           


            <div class="upload_wrap">
				<div class="left_box"> 

                    <el-upload
                        class="upload-demo"
                        drag
                        :action="this.$root.rootUrl+'saomiao_upload'"
                        multiple
                        accept=".jpg,.jpeg,.png,.bmp,.tiff,.tif,.jp2,.JPG,.JPEG,.PNG,.BMP,.TIFF,.TIF,.JP2"
                        :limit="10"
                        with-credentials
                        :http-request="UpLoadFilesHandle" 
						:data="uploadData"
						:on-success="handleUploadSuccess"
						:show-file-list="false"
						:before-upload="handleUploadbefore" 
						:on-progress="handleUploadProgress"
						:on-remove="handleRemoveFile" 
                        :file-list="file_list"

                        >
                        <!-- :file-list="file_list" -->
 
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__span">将文件拖到此处，或<em>点击上传</em> <br> <span style="font-size:12px;color:#575656">注：加密文件，请解密后再上传</span>  </div>
                        
                     
                        <div class="el-upload__tip" slot="tip">
                            <div style="width:50%;height:30px;margin-top:5px;margin-left:auto;margin-right:auto">
                                <el-progress :text-inside="true" :stroke-width="24" :percentage="uploadPercent" status="success" ></el-progress> 
                            </div>
							<!-- <p>暂支持的音频格式有：'wav','flv','mp4','m4a','mp3','amr'。</p> -->
                            <p> 仅可上传图片文档。图片大小限制10M，目前支持的格式有：jpg，jpeg，png，bmp，tiff，tif，jp2。 </p>
                            <p>后期 <span style="color:red">仅限会员</span>使用,每天可处理100次任务。目前在测试阶段。</p>
							<p>已上传列表最多只能有10个文件，如上传文件后数量超过10个，需要先删除才能继续上传。当前还可上传 ：<span style="color:red;font-weight:bold;font-size:14px"> {{10-file_list.length}} </span>  个 </p>
                            <!-- <p>仅可上传pdf后缀文档。上传文件大小限制20M。  <span style="color:red">请保证上传文件前法币余额充足。</span>  结果生成后，根据分钟多退少补，向上取分钟整数。</p> -->
						 

						</div>
                     </el-upload> 

                         
 
				 

				</div>

			 

		 

				<div class="right_box" >

					<span style="font-size:22rpx;margin-top:10px;text-align:center">已上传列表 <p style="font-size:14px">（按时间显示前10个，服务端保存24h后自动删除，也可主动删除）</p> </span>
                    <!-- <div class="reuslt_bar"  style="margin-top:10px" >
						<div class="res_item" style="width:10%;"> 序号 </div>
						<div class="res_item"  style="width:65%">文件名</div>
						<div class="res_item"  style="width:20%">选择</div>

                
		 
					</div>

					<div   style="width:100%"> 
						<div  class="reuslt_bar" v-for="(item,index ) of file_list"  v-bind:key="item._id" >
							<div class="res_item" style="width:10%;"> {{index+1}} </div>
							<div class="res_item"  style="width:65%">{{item.fileName}}</div>
                            <div   class="res_item"  style="width:20%">  </div>
					 
						</div>
					</div> -->

                    <el-table
                        ref="multipleTable"
                        :data="file_list"
                        tooltip-effect="dark"
                        style="width:100%;padding-left:10px; max-height: 500px;overflow-y: scroll;"
                        @selection-change="handleSelectionChange">
                         
                        <el-table-column
                        label="序号"
                        width="50">
                        <template slot-scope="scope">{{  scope.$index+1}}</template>
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="文件名"
                        width="200">
                        <template slot-scope="scope">{{ scope.row.fileName }}</template>
                        </el-table-column>


                        <el-table-column
                        prop="name"
                        label="缩略图" 
                        width="160">
                                 <!-- :preview-src-list="origList"
                                    :initial-index="preview_index" 
                                    @click="getPreviewList(scope.$index)" -->
                            <template slot-scope="scope"> 
                                <el-image 
                                    :preview-src-list="origList"
                                    :initial-index="scope.$index" 
                                    @click="getPreviewList()"
                            
                                    fit='contain' 
                                    style="height:100px;"
                                    :src="'https://www.lawtip.cn/temp/r/' + scope.row.userId+scope.row.uploadtime+'_1.'+scope.row.fileName.split('.')[1]  " 
                                    >
                                </el-image>
                                    <!-- @click="getSrcList" -->
                                <!-- :preview-src-list="srcList" -->

                            </template>
                        </el-table-column>



                        <el-table-column
                        type="selection"
                        width="50">
                        </el-table-column>

                        <el-table-column
                         
                            label="操作"
                            width="70">
                            <template slot-scope="scope">
                                <el-button @click="remove_file(scope.row)" type="text" size="small">删除</el-button>
                                <!-- <el-button type="text" size="small">编辑</el-button> -->
                            </template>
                        </el-table-column>
                        
                    </el-table>

					<!-- <el-upload
						class="upload-demo"
						drag
						action="https://lawassist.oss-cn-hangzhou.aliyuncs.com"
						:multiple='false'
						accept=".wav,.flv,.mp4,.m4a,.mp3,.amr,.WAV,.FLAC,.OPUS,.M4A',.MP3,.AMR,.MP4"
						:limit="2"
						:http-request="UpLoadFilesHandle"
						:data="uploadData"
						:on-success="handleUploadSuccess"
						:file-list="file_list"
						:before-upload="handleUploadbefore" 
						:on-progress="handleUploadProgress"
						:on-remove="handleRemoveFile"
						>
						<i class="el-icon-upload"  ></i>
						<div class="el-upload__span" >将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">
							<p>暂支持的音频格式有：'wav','flv','mp4','m4a','mp3','amr'。</p>
							<p>收费方式：0.2法币/分钟，会员0.15/分钟。上传后需根据文件大小按照0.2/M先支付法币押金，<span style="color:red">请保证上传文件前法币余额充足。</span>  结果生成后，根据分钟多退少补，向上取分钟整数。</p>
							<p>非实时转换，限制文件大小500M。操作后，请过一会儿再查看记录，最快五分钟内出结果。如果超过1小时没有出结果，请咨询客服微信:dfc0829 </p>
							<p>本功能由腾讯AI训练实现，随着训练的加深，效果会不断提升。</p>

						</div>
					</el-upload> -->


		 
	 
					<!-- $state.store.isLogin -->
					<el-button v-if="$store.state.islogin" :type="uploadSig==true? 'info': 'primary'" :disabled="uploadSig"   style="margin-top:25px;min-width:160px" @click="start_tran">
						{{uploadSig==true? '文件尚未上传处理完毕，请稍等': '开始转换' }}
					 
						
					</el-button>

					<el-button v-else type="info" disabled style="margin-top:25px;width:160px"  >请先登录</el-button>

				</div>
			</div>

 
 

            <!-- <div class="html_content"  v-html="article.content"  :style="isphone? 'width:'+screenWidth*0.98+'px':''  "></div> -->

            <!-- <div class="pdfwrap" id='pdfwrap'  v-if=' !this.article.content && article.files && article.files.length>0 && article.files[0].fileName.indexOf(".pdf")!=-1 && pdflink'  >
              <pdf 
                ref="pdf"
                :src="pdflink"
                 v-for="i in pdfNumPages"
                :key="i"
                :page="i"
                >
              </pdf>


            </div> -->

            
                   
            <!-- <div class="result_bar"  >
             
                <img v-for="(item ) of imgList"  v-bind:key="item" :src="item"  class="img_box" />

            </div> -->
 
            <imgList2   :affixfileList="imgList"> </imgList2>
            <div style="width:100%;padding:5px;  ">   <el-button @click="downLoadHandle" style="float:right;margin-right:20px" type="success">批量下载结果</el-button> </div> 
   
          </div>
          <!-- <div class="right" v-if="!isphone"></div> -->
























        </div>
       
    

     
 
        
  
  
       
      </div>
  
     
</template>

<script>


 
import QRCode  from "qrcodejs2"
// import VueQArt from 'vue-qart'

// var wx = require('weixin-js-sdk');
import wx from 'weixin-js-sdk'
import axios from 'axios'
import saveAs from '@/assets/js/html2word/FileSaver.js'


import pdf from 'vue-pdf'
import imgList2 from '@/components/yu/imgList2.vue'

import JSZip from 'jszip'
// import FileSaver from 'file-saver'


// var pdf = require('vue-pdf').pdf;

// import Base64 from 'js-base64'

// import VueCookies from 'vue-cookies';
// Vue.use(VueCookies)


var weixinJDK={}
weixinJDK.timestamp=Date.parse(new Date())/1000
weixinJDK.appId= 'wx5b2080a9450184a9'
weixinJDK.nonceStr=random_str(16)
// weixinJDK.jsApiList=['updateAppMessageShareData','updateTimelineShareData']


let datas_1= { 
  weixinJDK: weixinJDK,
  url:window.location.href
}

  // this.axios.withCredentials=false
axios.post('https://www.lawtip.cn/PHPserver/weixin/get_wxjdk.php', {
params: datas_1 },{withCredentials:false}
  ).then( (res)=> {
    // window.console.log(res)
    if(res.status==200){
      var result=res.data
      // window.console.log(result)
      weixinJDK.signature=result
      // window.console.log('weixinJDK:',weixinJDK)
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: 'wx5b2080a9450184a9', // 必填，公众号的唯一标识
        timestamp:  weixinJDK.timestamp, // 必填，生成签名的时间戳
        nonceStr:weixinJDK.nonceStr, // 必填，生成签名的随机串
        signature: weixinJDK.signature,// 必填，签名
        jsApiList: ['updateAppMessageShareData','updateTimelineShareData','onMenuShareAppMessage','onMenuShareTimeline','showMenuItems','hideMenuItems','miniProgram.navigateTo','miniProgram.navigateBack','wx.miniProgram.postMessage','wx.miniProgram.getEnv'] // 必填，需要使用的JS接口列表  
        //“分享给朋友”及“分享到QQ” ,“分享到朋友圈”及“分享到QQ空间”
      });

      // if(result.status=='ok'){
      //   weixinJDK.signature=result.data
      // }


    }
    
}).catch(function (error) {
  window.console.log(error);
});


wx.ready(function(res){
  window.console.log(res);
  // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。

});

wx.error(function(res){
  window.console.log(res);
  // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
});


wx.ready(function (res) {    
  window.console.log(res);
  wx.updateAppMessageShareData({ 
    title: document.title, // 分享标题
    desc: document.title, // 分享描述
    link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: 'https://www.lawtip.cn/images/logo.png', // 分享图标
    success: function () {
      // 设置成功
      window.console.log('success');
    },
    fail(res){
      window.console.log('fail res:',res);
    }
  })
});

wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
  wx.updateTimelineShareData({ 
    title: document.title, // 分享标题
    link: window.location.href,  // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: 'https://www.lawtip.cn/images/logo.png', // 分享图标
    success: function () {
      // 设置成功
      window.console.log('success');
    },
    fail(res){
      window.console.log('fail res:',res);
    }
  })
});


// wx.ready(function () {   
//   window.console.log('wx.showMenuItems():',wx.showMenuItems())

// });


function random_str(number){
  return Math.random().toString(36).substr(2).slice(1,number+1)
}

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

function getNum() {
  var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
      'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
      'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
      'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
      'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
      'x', 'y', 'z'];
  var nums = "";
  for (var i = 0; i < 8; i++) {
    var id = parseInt(Math.random() * 61);
    nums += chars[id];
  }
  return nums;

}

function delCookie () {  //清空所有cookie
    var keys = document.cookie.match(/[^ =;]+(?==)/g)
    if (keys) {
        for (var i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
        document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
        document.cookie = keys[i] + '=0;path=/;domain=ratingdog.cn;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
        }
    }
}

 
const loadZip = async (fileArr, zipName = '下载文件') => {
  fileArr.forEach(el=>{
    // el.fvName = `${el.fileName}.${el.link.split('.')[-1] }`  // 截取url的后缀名添加到文件名： fvname.jpg
    el.fvName=el.fileName
  })
  const zip = new JSZip() // 创建实例对象
  const promises = []
  // 遍历生成下载文件
  fileArr.forEach((item) => {
    const promise = getFile(item.link).then((res) => {
      const fvName = item.fvName + ''
      // 创建文件用file()，创建文件夹用 floder()
      zip.file(fvName, res.data, {
        binary: true
      })
    })
    promises.push(promise)
  })
    /** 
        Promise.all() 静态方法接受一个 Promise 可迭代对象作为输入，并返回一个 Promise。当所有输入的 Promise 都被兑现时，返回的 Promise 也将被兑现（即使传入的是一个空的可迭代对象），并返回一个包含所有兑现值的数组。如果输入的任何 Promise 被拒绝，则返回的 Promise 将被拒绝，并带有第一个被拒绝的原因。
        只有当all([p1, p2, p3]) 中的每一个 Promise 实例的状态都变成 fulfilled, Promise.all()的状态才会变成 fulfilled，此时  p1, p2, p3 的返回值组成一个数据，传给 Promise.all()的回调函数
        只要 p1, p2, p3 中任何一个被 rejected,  Promise.all() 的状态就会变成 rejected，此时第一个被 rejected 的实例的返回值，会传给 Promise.all()的回调函数。
        在上面的代码中，promises 数组中的每一个元素，都是 Promise 实例，所以需要用到 Promise.all()
    */
  // 生成 zip 文件
  Promise.all(promises).then(() => {
    // 生成zip 文件
    zip.generateAsync({
      type: 'blob',  // 文件格式
      compression: 'DEFLATE', // STORE: 默认不压缩， DEFLATE：需要压缩
      compressionOptions: {
        level: 9 // 压缩等级 1~9   1 压缩速度最快， 9 最优压缩方式
      }
    }).then((res) => {
      saveAs(res, `${zipName}.zip`) // 使用FileSaver.saveAs保存文件，文件名可自定义
    })
  })
}
// 这一步为下载文件步骤，通过传入的url下载文件
// 将文件 url 格式转换为 Bolb 类型格式 或者 arraybuffer 格式
const getFile = (fvUrl) => {
  return new Promise((resolve, reject) => {
    axios(fvUrl, {
      method: 'get',  // get请求
      responseType: 'blob', // 返回的数据会被强制转为blob类型 ，转换成arraybuffer 也行
      withCredentials: false 
    }).then((res) => {
      resolve(res) // 将下载的文件返回
    }).catch(err => {
      reject(err)
    })
  })
}
 
      





 import { IncUseNumber } from '@/assets/js/cal/cal';  







export default {
        name: 'saomiao_handle',
        // inject:['reload'],
        components: {
          //  QRCode,
          pdf,imgList2
 
        },
        metaInfo: {
            title: '扫描助手', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '扫描全能,文件扫描'
            }],
      
        },
		// props: {
		// 	pageId: String
        // },
        data() {
			return { 
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                isphone:false,
                imgList:[],
                origList:[],
                preview_index:0,
                
                pdflink:'',
                previewPdf:"",
                pdfNumPages: null,
                pdfPages:null,

                upload_num:1,

                islogin:false,
                userInfo:{},
                accountInfo:{},
               

                mode:'ori',
                files:[],
                ua:'',
                isMini:false,
                token:'',
         
             
                i:0,  //滚轮上下监听元素
                bottom_op_onshow:false,
                bottom_op_onshow_sig:0,
                isstared:'no',
                docid:'',
 

                scroll_timeout:'',
                uploadPercent:0,
                uploadData:{
                    'whattodo':"upLoadFiles"
                },
                file_list:[],
                tableData:[],
                multipleSelection:[],
                uploadSig:false, //是否有文件上传的标志，1为有，0为无
                param:{}
              
            }
        },
        created(){
          wx.miniProgram.getEnv(function(res) {
            window.console.log(res.miniprogram) // true
          })

          // window.console.log(navigator.userAgent)
        
          


          this.islogin=sessionStorage.getItem('isLogin') || false;

    

         
          if(this.islogin){
            let userInfo=sessionStorage.getItem('userInfo') || ''
            let accountInfo=sessionStorage.getItem('accountInfo') || ''

            window.console.log('userInfo:',userInfo)
            if (userInfo){
              this.userInfo= JSON.parse(userInfo)
            }
            if (accountInfo){
              this.accountInfo= JSON.parse(accountInfo)
            }

           window.console.log('this.userInfo:',this.userInfo)  

          }


           var that=this
 
           
        

        
       

             

     
        },
        mounted() {
           //  window.console.log('this.islogin:',this.islogin)
            IncUseNumber('saomiao_handle')

            var x=document.getElementById("head_tip")
            if(x){
              x.remove(0)
            }

            

          

        
            // this.$emit('ChangeFunctionBox','header_onshow_off'); 

            let ua=navigator.userAgent
            let isMini=ua.indexOf("miniProgram") 
            this.us=ua
            if(isMini!=-1){
              this.isMini=true
               
            } 
            window.console.log('this.isMini:',this.isMini)
            if(this.isMini){
              // window.console.log('----------------------------------' )
              this.isstared=this.$route.query.isstared
              this.token=this.$route.query.token

              // this.mini_code=this.$route.query.code

         
             
             
            }else{
              this.isstared=sessionStorage[this.docid]
            }
           
            this.isphone=isphone()

            // if(this.isphone){



            // }
             


          
            window.scrollTo(0,0);
         

            this.getImgFileList()














            // if (d){
            //   window.console.log('yes');
              // this.weixinJDK=JSON.parse(d);
              // that.weixinJDK=JSON.parse(d)
              // wx.config({
              //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              //   appId: 'wx5b2080a9450184a9', // 必填，公众号的唯一标识
              //   timestamp:  Date.parse(new  Date())/1000, // 必填，生成签名的时间戳
              //   nonceStr: random_str(16), // 必填，生成签名的随机串
              //   signature: '',// 必填，签名
              //   jsApiList: ['updateAppMessageShareData','updateTimelineShareData'] // 必填，需要使用的JS接口列表
              // });
            // }
            // if(!that.weixinJDK || that.weixinJDK.timestamp)
           
            
        },
        methods:{
          //  beforeRouteLeave(to, from, next) {
          //       // 设置下一个路由的 meta
          //       to.meta.keepAlive = true;  // B 跳转到 A 时，让 A 缓存，即不刷新
          //       next();
          //   },
          // reload () {
          //     this.isRouterAlive = false;            //先关闭，
          //     this.$nextTick(function () {
          //         this.isRouterAlive = true;         //再打开
          //     }) 
          // },
 


          BackToHome(){ 
            this.$router.push({name:'community'})
            this.$emit('ChangeFunctionBox','header_onshow_on'); 
          },

         downLoadHandle(){
                if(this.imgList.length==0){
                    this.$message({
                        message: '没有需要下载的图片',
                        type: 'warning',
                        duration:4000,
                        showClose:true,

                    });
                    return
                    
                }

                console.log(this.imgList)
                
                let imageUrls=[]

                // for(let p of this.imgList){
                //     imageUrls.push(p.link)
    
                // }

                // downloadImages(this.imgList)

                loadZip(this.imgList,'云助理扫描王')




            },
         
           
        
           

          Turn2Profile(){
            wx.miniProgram.navigateTo({url: '/pages/tools/intro/intro_detail?id='+this.article.userid})
          },
      
        
          
            crateQrcode () {
              this.qr = new QRCode('qrcode', {
                width: 150,
                height: 150, // 高度
                text: window.location.href // 二维码内容
                // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f'
                // foreground: '#ff0'
              })
              // console.log(this.qrcode)
            },
            // 关闭弹框,清除已经生成的二维码
            closeCode () {
              this.$refs.qrcode.innerHTML = ''
            },

            errorHandler() {
                return true
            },
            
      

            BackToLastPage(){
              this.$router.go(-1)
            },

      



            handleScroll(){
              // 页面滚动距顶部距离
              var that=this
              // let x=document.getElementById("pdfwrap")
              // var scrollTop = x.scrollTop
              var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 
                        document.body.scrollTop
            

              var scroll = scrollTop - this.i;
              this.i = scrollTop;
              // window.console.log('scrollTop:',scrollTop)
              // window.console.log('scroll:',scroll)
              if(scroll<0){
                // window.console.log('up')
                // window.console.log('scrollTop:',scrollTop)
              
              }else{
                // window.console.log('down')
                // window.console.log('scrollTop:',scrollTop)
                // window.console.log(document.documentElement.clientHeight)
                // window.console.log(window.innerHeight)
              

      

                this.bottom_op_onshow=true  // 评论区 star区是否显示
                clearTimeout(this.scroll_timeout)
                this.scroll_timeout= setTimeout(()=>{this.bottom_op_onshow=false}, 5000 )
              // clearTimeout()
                // window.console.log('that.commentsWindow:',that.commentsWindow)

                if(that.commentsWindow==true){   //评论的dialogue是否显示
                  // window.console.log('+++++that.commentsWindow:',that.commentsWindow)
                  var destination = document.querySelector("#comments");
           

                  //clientHeight+clientHeight>=scrollHeight 的时候滚动条到底部
                  
                  if(that.comments_sig){
                    window.console.log('this.comments_sig:',that.comments_sig)
                    if(destination.scrollTop+destination.clientHeight>=destination.scrollHeight){
                      // let page=that.comment_page+1
                      that.comment_page++
                      that.CommentHandle('',that.comment_page)
                    }
                  }
                  

                }

 
               
               
              }
            },

            timestampToTime(timestamp) {
                if(!timestamp){
                  return ''
                }
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + '';
                // var h = date.getHours() + ':';   //
                // var m = date.getMinutes() + ':';//
                // var s = date.getSeconds();//
                if (M.length==1){
                    M='0' +M
                }
                if (D.length==1){
                    D='0' +D
                }
                return Y + M + D ;  //+ h + m + s
            },

         

            mouseOverItem(index){
              // window.console.log('e:',e);
              // var itemId=e.srcElement.dataset.itemId
              var itemId='file_'+index
              window.console.log('itemId:',itemId);
              // let x=document.getElementById(itemId)
              // window.console.log('x:',x);
              document.getElementById(itemId).style.color="red";
            },
            mouseLeaveItem(index){
              window.console.log('itemId:');
              var itemId='file_'+index
              document.getElementById(itemId).style.color="black";
            },





            

            getfilelink(file ,needcoin=false){
              var that=this
              var datas= { 
                whattodo: "getDownLoad",
                articleId:that.article.docid,
                fileName:file.fileName
              }
              // datas['param']=this.param
              this.axios.post( this.$root.rootUrl+'article',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                    }else if (result.status=='ok'){
               
                      let link=result.link
                      link=link.replace("http://",'https://')
                      that.pdflink=link

                      let loadingTask = pdf.createLoadingTask(that.pdflink)
                      loadingTask.promise.then(pdf => {
                        that.pdfNumPages = pdf.numPages
                        // let x=document.getElementById("pdfwrap")
                        // console.log('x:',x)
                        // console.log('x.scrollTop:',x.scrollTop)

 

                       
                        // if( pdf.numPages<=5){
                        //   that.pdfPages= pdf.numPages
                        // }else{
                        //   that.pdfPages=5
                        // }
                      
                      
                      }).catch(err => {
                        console.error('pdf 加载失败', err);
                      })

              


                    } else if (result.status=='fail'){
                      // window.console.log('get download link fail')
                      // that.$message.error(result.failMsg);
                        
                    }

                }
                
              }).catch(function (error) {
                  window.console.log(error);
            
              });



            },


           

            getPreviewList(index){
                let a=[]
                console.log(this.file_list)
                
                for(let p of this.file_list){
                    let link='https://www.lawtip.cn/temp/r/'+p.userId + p.uploadtime +'_1.'+p.fileName.split('.')[1]
                    a.push( link)
                }
                this.origList=a
                this.preview_index=index
                console.log(a)

            },
           

            Turn2Charge(){
              this.$router.push({path:'/deposit'})

            },


            refresh_coins() {
              var that=this

              console.log("this.$store.state.userInfo.userId:",this.$store.state.userInfo.userId)

              var datas= { 
                // userid: this.$store.state.userInfo.userId,
                userid:that.$root.userInfo.userId,
                whattodo:'getCoins',
              }
              this.axios.post('https://api.lawtip.cn/userinfo',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                  var result=res.data
                  window.console.log('result:',result,'result.status:',result.status)
                  if (result.status=='ok'){
                    that.myCoins=result.coins
                    that.$root.accountInfo.coins=result.coins

                    that.$store.commit('SetNewCoins',result.coins)

                  } 
                  else if (result.status=='fail'){
                    that.$message('获取余额失败，请稍后再试');
                    
                  } 

    

				}


				
			}).catch(function (error) {
				window.console.log(error);

			});


            },
            
            getImgFileList(){
                var that=this
                var datas= { 
                    whattodo: "get_saomiao_list",
                    mode:this.mode,
                    // articleId:that.article.docid,
                    // files:this.multipleSelection,
                    param:this.param,
                }
          
              this.axios.post( this.$root.rootUrl+'dochandle',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                    }else if (result.status=='ok'){
               
                        that.file_list=result.data 

                     
              


                    } else if (result.status=='fail'){
                   
                        
                    }

                }
                
              }).catch(function (error) {
                  window.console.log(error);
            
              });

         



            },
            delete_file(uploadtime){
                var that=this
                var datas= { 
                    whattodo: "delete_file",
                    uploadtime:uploadtime,
                 
                }
          
              this.axios.post( this.$root.rootUrl+'dochandle',datas
              ).then(function (res) {
                // window.console.log(res)
                if(res.status==200){
                    let result=res.data
                    if (result.status=='ok'){
                        console.log('delete success')
                 

                     
              


                    } else if (result.status=='fail'){
                   
                        
                    }

                }
                
              }).catch(function (error) {
                  window.console.log(error);
            
              });

            },



 

            SignIn(){
                window.console.log('SignIn')
                // this.SignInVisibl=true 
                let num= getNum()
                var nowurl = window.location.href;
                let target=window.btoa(nowurl)
                let state=num+'(redirect)'+target
                // let url='https://open.weixin.qq.com/connect/qrconnect?appid=wxe00435b975483ad0&redirect_uri=http%3a%2f%2fwww.lawtip.cn%2fPHPserver%2flawtipLogin.php&response_type=code&scope=snsapi_login&state='+num+'#wechat_redirect'
                let url='https://open.weixin.qq.com/connect/qrconnect?appid=wxe00435b975483ad0&redirect_uri=http%3a%2f%2fwww.lawtip.cn%2flogin&response_type=code&scope=snsapi_login&state='+state+'#wechat_redirect'
                
                // sessionStorage.setItem("login", "yes");
                localStorage.setItem("loginStatus", num);
                window.open(url,"_self")


                // window.open('http://www.lawtip.cn/wenshuDetail.html?'+timestamp, '_blank')

            },

            SignOut(){
                var that=this
                window.console.log('SignOut')
                delCookie()
           
                this.islogin=false

                sessionStorage.removeItem("isLogin");
                sessionStorage.removeItem("userInfo");
                sessionStorage.removeItem("accountInfo");

               
    

                // this.$notify({
                //     title: '成功',
                //     message: '成功退出登录',
                //     type: 'success'
                // });

                this.axios.get('../PHPserver/login/SignOut.php',{
                // params: {
                //     timestamp:timestamp
                // }
                }).then(function (res) { 
                    if(res.status==200){
                        window.console.log(res.data)
                        let result=res.data
                        if(result.status=='ok'){
                            // that.$root.userInfo=result.userInfo;
                            // that.$root.accountInfo=result.accountInfo;             			
                            that.islogin=false
                            that.userInfo.avatarUrl='@/assets/images/touxiang.png'
                            // window.open('/',"_self")
                            window.open(window.location.href,"_self")
                        }        


                    }

                }).catch(function (error) {
                    window.console.log(error);
                });






                

            },

            handleUploadbefore(file){
                window.console.log('handleUploadbefore--' )
                if(!this.$store.state.islogin){
                    this.$message.error('您需要先登录才能上传哦');
                    return false
                }

                // if(this.$store.state.accountInfo.vip!=1){
                //     this.$message({
                //         message: '非常抱歉~该功能仅限会员使用。',
                //         type: 'warning',
                //         showClose: true,
                //         duration:4000,
                //     });
                //     return


                // }
                
         
                let m1=1048576   //1M 的bytes

            
                const fileType = file.type  ;
                const isLt50M = file.size < 20*1048576 ;
                if (!isLt50M){
                    this.$message.error('上传文件大小不能超过20MB!');
                    return false
                }
                
                // var deposit=Math.ceil(file.size/m1)*0.2
               
                // let myCoins=this.$store.state.accountInfo.conis
              
                // if (myCoins<deposit) {
                //     this.$message.error('根据每M文件大小0.2法币，您需要有至少'+deposit+'，请先充值哦');
                //     return false
                // } 

            
                if(isLt50M  ){ //&&fileType  大小符合条件，开始上传
                   
                    this.uploadData.filename=file.name
        
                    this.uploadData.whattodo="upLoadFiles"
                    // this.uploadData.userid=this.$root.userInfo.userId
                    
                    this.uploadSig=true
                    return isLt50M  // &&fileType;
                }else{
                    console.log('false')
                    return false
                }
                

            },
            handleUploadSuccess(res, file){  //没用

                // this.$notify({
                // 	title: '成功',
                // 	message: '上传成功,请稍后查看记录获取下载地址。或继续上传新文件。',
                // 	type: 'success',
                // 	duration: 7000
                // });


                // window.console.log('res:',res)
                // window.console.log('file_list:',this.file_list)
                // window.console.log('upload success file: ',file)
                const h = this.$createElement;
                var that=this
        
                if(res.status=='ok'){
                    that.$notify({
                        title: '成功',
                        message: '上传成功,请稍后查看记录获取下载地址。或继续上传新文件。',
                        type: 'success',
                        duration: 5000
                    });
            
                }else if(res.status=='badgate'){
                
                    that.$notify({
                        title: '注意',
                        message: h('i', { style: 'color: teal'}, '登录超时，请重新登录'),
                        duration: 5000
                    });
                    this.file_list=[]
    
                }else if(res.status=='fail'){
                if(res.errCOde=='4002'){

                    that.$notify({
                        title: '注意',
                        message: h('i', { style: 'color: teal'}, '文件过大，不超过20M。'),
                        duration: 6000
                    });
                    this.file_list=[]
                
                }

                }


            },
            

            

            handleRemoveFile(file, fileList){
                // this.file_list=[]
                // window.console.log('++++file:',file)
                // window.console.log('----fileList:',fileList)
                if(this.file_list.length>0 && file.uid==this.file_list[0].uid ){  //删除的是文件列表中的但未处理的文件
                    this.file_list=[]
                    this.uploadPercent=0
                }

            },

            UpLoadFilesHandle(val){
                var that=this
                console.log('val1:',val)
                var file=val.file
                var filename=file.name
               
                this.fileName=filename

            
                // console.log(" this.fileName:",this.fileName)


                let fd=new FormData()
                
                // fd.append("policy",token.policy);
                // fd.append("OSSAccessKeyId",token.accessid);
                // fd.append("signature",token.signature);
                // fd.append("key",this.osspath);
        
                // fd.append("success_action_status",'200');
                fd.append("file", file);
                fd.append("filename", filename);
                // let uploadtime=Math.floor(file.lastModified/1000) 
                // let uploadtime= new Date().getTime()+this.upload_num // Math.floor(new Date().getTime()/1000) 
                let uploadtime= new Date().getTime()/1000+this.upload_num
                uploadtime= uploadtime.toFixed(3)
                this.upload_num++
                // uploadtime=uploadtime % 1000000000
                console.log('uploadtime:',uploadtime)

                //  

                fd.append("uploadtime",uploadtime );
                fd.append("whattodo", 'upLoadFiles');

                console.log("file.lastModified:",file.lastModified)

                const url =this.$root.rootUrl+'saomiao_upload'
                this.axios.post(url,fd,{ 
                    // withCredentials:false,
                    headers: {"content-type": "multipart/form-data"},
                    onUploadProgress: function (progressEvent) { //原生获取上传进度的事件
                        // console.log('progressEvent:',progressEvent)
                        if (progressEvent.lengthComputable) {

                            that.uploadPercent=Math.floor( 100*progressEvent.loaded/progressEvent.total)
                            //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
                            //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
                            // callback1(progressEvent);
                        }
                    },
            
                },
                
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        var result=res.data
                        if(result.status=='ok'){
                          that.$notify({
                              title: '成功',
                              message: '上传成功。',
                              type: 'success',
                              duration: 4000
                          });

                          // that.start_tran(that.osspath)
                          that.file_list.push( {fileName:file.name,uploadtime : uploadtime, userId: that.$store.state.userInfo.userId  } )
                          console.log('=====file_list:',that.file_list)


                        }else{
                          that.$notify({
                              title: '上传失败',
                              message: result.errMsg,
                              type: 'warning',
                              duration: 4000
                          });


                        }
               
                        that.uploadSig=false
                    }


                    
                }).catch(function (error) {
                    window.console.log(error);

                });


            


            },

            remove_file(row){
                console.log('row:',row)
                let file_list=this.file_list
                let len=file_list.length 
                for(let p=0;p<len;p++){
                    if(file_list[p].uploadtime== row.uploadtime  ){
                        file_list.splice(p,1)
                        this.file_list=file_list 

                        this.delete_file(row.uploadtime)

                        break
                    }


                }


            },

            handleUploadProgress(event, file, fileList){
                console.log('---------------')
                console.log('res:',res)
                console.log('file:',file)
                console.log('fileList:',fileList)

                console.log('---------------')


            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log("this.multipleSelection:",this.multipleSelection)
                // let len=this.multipleSelection.length 

                // if(this.mode=='split' && len>1){
                //     this.$notify({
                //         title: '提醒',
                //         message: 'pdf拆分，只能选择一个pdf文件操作哦，请先取消多余的选择后再操作',
                //         type: 'info',
                //         duration: 7000
                //     });
                // }

            },

            toggleSelection(rows) {
                if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
                } else {
                this.$refs.multipleTable.clearSelection();
                }
            },

            // work(){
            //     let mode=this.mode 


            // },
            

            start_tran(){
              var that=this

            //   if(this.$store.state.accountInfo.vip!=1){
            //     this.$message({
            //         message: '非常抱歉~该功能仅限会员使用。',
            //         type: 'warning',
            //         showClose: true,
            //         duration:4000,
            //     });
            //     return


            //   }
              
              let param=this.param
              if(this.multipleSelection.length==0){
       
                this.$message({
                    message: '请先选择一个文件操作对象',
                    type: 'warning',
                    showClose: true,
                });
                return

              }

                if(this.multipleSelection.length>5){
       
                    this.$message({
                        message: '暂时只支持最多五个文件的处理',
                        type: 'warning',
                        showClose: true,
                    });
                    return

                }

             


              var datas= { 
                whattodo: "trans_saomiao",
                mode:this.mode,
                // articleId:that.article.docid,
                files:this.multipleSelection,
                param:this.param,
              }
              // datas['param']=this.param


              const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });


              this.axios.post( this.$root.rootUrl+'dochandle',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                    loading.close();
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                    }else if (result.status=='ok'){
               
                        //   let link=result.link
                        //   link=link.replace("http://",'https://')
                        that.toggleSelection()
                        // that.multipleSelection=[]
                        // that.$set(that.multipleSelection,'arr',arr);

                        that.imgList=result.data 
                
                        //     that.$notify({
                        //         title: '提醒',
                        //         message: '下载链接：'+link,
                        //         type: 'success',
                        //         duration: 0
                        //     });


                        //   window.open(link,"_blank")


                     
              


                    } else if (result.status=='fail'){
                        that.$message({
                            message: result.failMsg,
                            type: 'warning',
                            showClose: true,
                            duration:5000,
                        });
                        return
                      // window.console.log('get download link fail')
                      // that.$message.error(result.failMsg);
                        
                    }

                }
                
              }).catch(function (error) {
                   loading.close();
                  window.console.log(error);
            
              });

            }


        
        }























        

       


    }
</script>

<style   > 

  [v-cloak] {
    display: none;
  }

  	body
{

    /* background-color: #f0f0f0; */
    background-color: #fff;
} 

  .affix{
    display: flex;
    flex-direction: column;
    width:100%;
    /* border: 1px solid #aaa9a9; */
    margin-top:10px;
    /* padding-top:10px; */
  }
  .affix a{
    text-decoration: none;
    color:black;
  }

  .affix .firstline{
    height: 35px;
    width:100%;
    /* padding: 8px 16px; */
    
    background-color: #f1f8ff;
    line-height: 35px;
    /* padding-left:15px; */
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

 

  .affix .firstline .left{
    width:60%;
    height: 100%;
  }

  .affix .firstline .right{
    width:40%;
    height: 100%;
    justify-content: flex-end;
    padding-right: 10px; 
    font-size:14px;
 
  }


  .affix .item{
    height: 40px;
    line-height: 40px;
    width:100%;
    /* border: 1px solid #b62121; */
    /* padding-left:15px; */
    display: flex;
    flex-direction: row;
    /* align-items: center; */
    margin-top:0;
    cursor: pointer;
    overflow: hidden;

  }
  .affix .item .icon{
    width:5%;
    height: 100%;
    justify-content: center;
    align-items:center;

  } 

  .affix .item .icon img{
    width:30px;
    height:30px;
  }

  .affix .item .left{
    width:55%;
    height: 100%;
    /* border: 1px solid #575656; */

  }  

  .affix .item .mid{
    width:20%;
    height: 100%;
    /* border: 1px solid #dedede; */

  }  

  .affix .item .right{
    width:20%;
    height: 100%;
    justify-content: flex-end;
    padding-right:10px;

    /* border: 1px solid #bdbcbc; */
    display: flex;
    flex-direction: row;
    align-items: center;
  }  
  /* .affix .item .right button{
    height:70%;
  } */

.fileUpdateTime{
  margin:auto;
  font-size:12px;
  color:#9c9c9c;
}


  .editor_wrap{
   
    display: flex;
    flex-direction: column;
    /* width:1400px ; */
    /* border: 1px solid #333;  */
    margin-left: auto;
    margin-right: auto;
    /* justify-content: flex-start; */
  }

  .sharecode{
    /* border: 1px solid #d64545;  */
    margin:auto;
    /* margin-bottom:15px; */
  }
 

  .header_{
    width:100%;
    min-height: 55px;
    /* height: 55px; */
 
    border-bottom: 1px solid #e7e7e7; 
    display: flex;
    flex-direction: row;
  
 
    color:black;
    align-items: center;

  }

  .head_operation{
    width:40%;
    display: flex;
    flex-direction: row;
    /* border: 1px solid #ad3131;  */
    justify-content: flex-end;
    align-items:center;
    height: 100%;
    font-size:24px;
    padding-right: 15px;
  }

  .loginAvatar{
    width:10%;
    justify-content: flex-end;
    display: flex;
    flex-direction: row;
    align-items:center;
    text-align: right;
    height: 100%;
    /* border: 1px solid #ad3131;  */

  }

  .head_operation i{
    margin-left:50px;
    cursor: pointer;
  }

  .button_head{
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
 
  .middle{
    display: flex;
    flex-direction: row;
    /* padding-top:15px ;
    border: 1px solid rgb(185, 19, 19);  */
    /* margin-top: 55px; */

    /* border: 1px solid rgb(185, 19, 19);   */
    /* width:1400px; */
    /* background-color: #fff; */

  }

  .left ,.right{
    width:18%;
    /* border: 1px solid rgb(19, 40, 156);  */

  }
  .mid_{
    display: flex;
    flex-direction: column;
    width:96%;
    /* border: 1px solid rgb(211, 233, 14);  */
    /* flex-wrap: wrap; */
    word-wrap:break-word;
    word-break:break-all;

    padding:10px;
    margin-left: auto;
    margin-right: auto;
    /* background-color: #fff; */

  }

  .starBar{
    display: flex;
    flex-direction: row;
    width:100%;
    height: 40px;
    /* border: 1px solid rgb(211, 233, 14);   */
    justify-content: flex-end;
    align-items: center;
    line-height: 40px;
    /* position: relative; */

  }

  .starbox{
    border: 1px solid #c8e1ff;
    height: 80%;
    width:100%;
    margin-top:auto;
    margin-bottom: auto;
 
 
  }
  .starlikesnum{
    /* border-left: 1px solid #c8e1ff; */
    width:30%;
    height: 100%;
    font-size:22px;

  }
  .starBar .op{
    
    min-width:100px;
    height: 100%;
    /* border: 1px solid rgb(33, 88, 189);  */
    /* line-height: 60px; */
    /* padding: 5px; */
    cursor: pointer;
    /* float:right; */
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left:10px;
    justify-content: center;
   
 
  }

   .starBar .op button{
     height: 70%;
   }

    .mode_bar{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
  
 
/* 
  .el-icon-star-on,.el-icon-star-off{
    line-height: auto;
 
    height: 100%;
    width:100%;
    border: 1px solid rgb(8, 22, 48);
  } */

  /* .mid p{
    overflow: wrap;
  } */

  /* .divcontent{
    border: 1px solid rgb(211, 233, 14); 
    width:100%;
 
  } */
/* 
  .divcontent .img{
    
  } */
/* 
  .mid img{

    max-width:100%;
  } */

  /* .mid_ img{
    max-width:100%;
    display: block;
    margin:auto;
  } */
  .mid_ pre{
    background-color:#e9e8e8;
    overflow:scroll;
  }

  .mid_ >>>  img{
    max-width:100%;
    display: block;
    margin:auto;
  }
  .mid_ >>> pre{
    /* background-color:#e9e8e8; */
    background-color: #F6F6F6;
    color: #121212;
    overflow:scroll;

    padding: 15px ;
  }


 

  .title{
    /* display: flex;
    flex-wrap: wrap; */
    min-height: 50px;
    width: 100%;
    line-height: 50px;
    font-size:30px;
    font-weight: normal;
  
    /* border: 1px solid rgb(211, 233, 14); */
  }
  .author{
    height: 50px;
    width:100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bottom{
    text-align: center;
    font-size: 12px;
  }

  .editor_class{
     height: 90%;
  }


  .bottom_op{
    height:60px;
    width:100%;
    /* border: 1px solid rgb(211, 233, 14);  */
    position:fixed;
    bottom:0;
    background-color: #fff;
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content: center;
    box-shadow:1.5px 1.5px 5px #909090;
   
  }
  .bottom_op_item{
    width:130px;
    height: 100%;
    /* border: 1px solid rgb(211, 233, 14);  */
    line-height: 60px;
    padding-left: 15px;
    cursor: pointer;
  }
  .bottom_op_icon{
    /* margin-left:45px; */
    /* line-height: 30px; */
    font-size:17px;
    font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
    color:#646464;
    cursor: pointer;
   
  }

  .html_content{
    /* border: 1px solid rgb(211, 233, 14); */
    /* padding-left:8px;
    padding-right:8px; */
  }

  .pdfwrap{
    margin-top: 10px;
    border: 1px solid #bebdbd; 
    border-radius: 5px;
    width:700px;
    /* height: 900px; */
    height: 800px;
  	/* width: 21cm; */
 
	  /* height: 29.7cm; */
    /* padding-left: 2cm;
    padding-top: 2cm;
    padding-right: 2cm;
    padding-bottom: 2cm; */

    margin-left: auto;
    margin-right: auto;
    overflow-y: scroll;

  }

  .tagsBar{margin-top:25px}
  .tagsBar span{
    margin-right:20px;
  }
 

  /* .bottom_op_font{
    margin-left:5px;
    cursor: pointer;
    font-size:16px;
   
  } */

  .comments_box{

    /* display: flex;
    flex-direction: column; */
    /* border: 1px solid rgb(211, 233, 14); */
    width:100%;
    height:500px;
    overflow-y: scroll;
    /* width:100%;
    height: 100%; */


  }

  .comments_box .titleBar{
    width:90%;
    height: 50px;
    /* border: 1px solid rgb(16, 160, 148); */
    position:absolute;
    top:5px;
    display: flex;
    flex-direction: row;
    align-items:center;

  }

   .comments_box .titleBar .comment_num{
    width:65%;
    /* border: 1px solid rgb(16, 160, 148); */
    height: 100%;
    line-height: 50px;
    font-size:20px;

   }
  .comments_box .sortbar{
    float:right;
    width:30%;
    height: 30px;
    /* border: 1px solid rgb(16, 160, 148); */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items:center;
    margin-bottom: 5px;
    ;
    
  }

   .comments_box .sortbar span{
    cursor: pointer;
   }

  .comments_box .sortbar img {
    margin-right: 15px;
  }

  .inputComment{

    /* position: absolute;
    bottom: 5px; */
    /* border: 1px solid  #a3a3a3; */
    width:100%;
    display: flex;
    flex-direction: row;
    /* justify-content: center; */
    align-items:center;

  }

  /* .inputComment el-input{
    width:80%;
  } */
   


.upload_wrap{
	display: flex;
	flex-direction: row;
	width:100%;
	border:1px solid #d4d4d4; 
	padding-bottom: 5px;
	margin-top: 15px;
    min-height: 500px;


}

.upload_wrap .left_box,.right_box{
	display: flex;
	flex-direction: column;
	align-items: center;
	/* border:1px solid #31b831;  */
	width:50%;
	padding-bottom: 30px;
 
}
 
.upload_wrap .left_box{
	/* max-height: 100%; */
	padding-left:5px ;
    /* width:35%; */
	overflow-y: scroll;
} 

/* .upload_wrap .right_box{
 
    max-height: 600px;
    overflow-y: scroll;
 
}  */

.reuslt_bar{
  width:100%;
  min-height:30px;
  max-height: 60px;
  /* height: 60rpx; */
  display: flex;
  flex-direction: row;
  line-height: 30px;
  /* flex-wrap: wrap; */
   
}

.res_item{
  border:1px solid #cfd8dc;
  text-align: center;
  overflow: hidden;
  word-wrap:break-word;
  word-break:normal; 
  padding: 0 2px 0 2px;
}


.upload-demo{
	margin-top:30px;
	padding: 6px;
	/* border:1px solid #222; */
	display: flex;
	flex-direction: column;

	justify-content: center;
	align-items: center;
}
.el-upload__tip{
	word-wrap:break-word;
	word-break:normal;
}

.tips{
	margin-top:80px;
	width:100%;
	/* border:1px solid #222; */
	font-size:12px;
	line-height: 20px;
	display: flex;
	display: flex;
	flex-direction: column;
}
.tips span{
	width:40%;
	/* min-height: ; */
	border:1px solid #222;
	word-wrap:break-word;
	word-break:normal;
	/* float:right; */
}

.history_button{
  width:100%;
  margin-top:30px;
  height: 40px;
  line-height: 40px;
  /* height: 60px; */
  /* float: right; */
  /* border:3px solid #1d495c; */
  /* display: flex;
  flex-direction: row;
  align-items: center; */

}

.history_bar{
  margin-top:25px;
  width:100%;
  height:30px;
  line-height: 30px;
  background-color: #cfd8dc;
  /* border:3rpx solid #cfd8dc; */
}

.current_task{
    margin-top: 10px;
    width: 100%;
    min-height: 30px;
    /* height: 50px; */
    border:1px dashed #969595;
    line-height: 28px;
    /* padding-top: ; */
    /* padding-top: 10px; */
}


.choosen_file{
    text-decoration:underline;
    color: rgb(19, 90, 84);
    margin-left: 25px;
    
  
}

.el-notification {
    white-space:pre-wrap !important; 
    
    word-wrap: break-word;
    word-break: break-all;
    
}


/* .result_bar{
    border:1px dashed #969595;
    min-height: 150px;
    display: flex;
    flex-direction: row;
    padding: 5px;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;

} */

.img_box{
    height: auto;
    width: 120px;
    margin-right: 15px; 
    margin-left: 10px;

    /* border:1px dashed #c5b5b5; */


}

.el-table th.el-table__cell{
    text-align: center;
}

/* .el-table .el-table__cell */


.el-table::before {
  display: none !important;
}


.guide{
  /* font-size:22rpx; */
  float: right;
  /* padding-right: 20rpx; */
  text-decoration: underline;
  margin-right: 20px;
  color: rgb(19, 109, 145);
  cursor: pointer;
}


</style>
